import { render } from "./customization.vue?vue&type=template&id=291e6dda"
import script from "./customization.vue?vue&type=script&lang=js"
export * from "./customization.vue?vue&type=script&lang=js"

import "./customization.vue?vue&type=style&index=0&id=291e6dda&lang=less"

import exportComponent from "../../../../node_modules/.pnpm/vue-loader@17.4.2_vue@3.5.21_webpack@5.101.3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__